// import { API_URL } from '@/lib/config';
import{API_URL}from"./config";// Memory API configuration
export const MEMORY_CONFIG={// Use the main API URL from config
apiUrl:API_URL,// API path for memory endpoints
apiPath:'/api/tutor/memory',// Path for visualization routes - this needs to match the server's structure
visualizationPath:'/api/tutor/memory',// Default user for testing - empty to use logged in user
testUserId:''};export default MEMORY_CONFIG;